import { ChangeDetectionStrategy,Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton,MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

import { SecretInputToggleComponent } from 'app/shared/components/secret-input-toggle.component';
import { Endpoint, HttpHeader } from 'app/shared/graph';

@Component({
    selector: 'admin-store-endpoint',
    templateUrl: './store-endpoint.component.html',
    styleUrl: './store-endpoint.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatError, MatHint, SecretInputToggleComponent, MatSuffix, MatIconButton, MatIcon, MatButton]
})
export class StoreEndpointComponent {
    @Input() endpoint: Endpoint;
    urlPattern = /^https?:\/\/.+$/;
    invalidUrlMessage = 'This url is not valid.';

    removeHeader(headers: Array<HttpHeader>, index: number): void {
        headers.splice(index, 1);
    }

    addHeader(headers: Array<HttpHeader>): void {
        headers.push({
            name: '',
            value: ''
        });
    }
}
